import { DEFAULTS, type BlacklistRule, type Params } from './domain'

export function modifiedCount(params: Params): number {
  return (Object.keys(DEFAULTS) as Array<keyof Params>).filter(
    key => params[key] !== DEFAULTS[key]
  ).length
}

// Shared by the single view and each batch preview so both use one API contract.
export function predictRequestBody(
  modelCodes: string[],
  nCars: number,
  params: Params,
  blacklist: BlacklistRule[],
) {
  return {
    model_codes: modelCodes,
    n_cars: nCars,
    blacklist,
    block_coverage_target: params.blockCoverageTarget,
    min_row_share: params.minRowShare,
    ess_threshold: params.essThreshold,
    single_option_threshold: params.singleOptionThreshold,
    pkg_weight: params.pkgWeight,
    color_weight: params.colorWeight,
    interior_weight: params.interiorWeight,
    rim_weight: params.rimWeight,
    weight_bto: 1 - params.btoVsBtsBalance,
    weight_bto_no_prod: 1 - params.btoVsBtsBalance,
    weight_bts: params.btoVsBtsBalance,
    recency_half_life_days: params.recencyHalfLifeDays,
    enable_option_clusters: params.enableOptionClusters,
    option_min_signature_share: params.optionMinSignatureShare,
    option_coverage_target: params.optionCoverageTarget,
    max_option_blocks_per_bundle: params.maxOptionBlocksPerBundle,
    min_block_share: params.minBlockShare,
    option_cross_weight: params.optionCrossWeight,
  }
}
